export const TID = {
  nav: {
    container: "site-nav",
    logo: "nav-logo",
    linkServices: "nav-link-services",
    linkAbout: "nav-link-about",
    linkProcess: "nav-link-process",
    linkQuote: "nav-link-quote",
    linkContact: "nav-link-contact",
    ctaQuote: "nav-cta-quote",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    section: "hero-section",
    title: "hero-title",
    quoteBtn: "hero-quote-btn",
    contactBtn: "hero-contact-btn",
  },
  why: {
    section: "why-section",
    card: (k) => `why-card-${k}`,
  },
  about: {
    section: "about-section",
  },
  services: {
    section: "services-section",
    item: (k) => `service-item-${k}`,
  },
  industries: {
    section: "industries-section",
    item: (k) => `industry-${k}`,
  },
  process: {
    section: "process-section",
    step: (k) => `process-step-${k}`,
  },
  quote: {
    section: "quote-section",
    form: "quote-form",
    name: "quote-name",
    company: "quote-company",
    email: "quote-email",
    phone: "quote-phone",
    origin: "quote-origin",
    destination: "quote-destination",
    typeAir: "quote-type-air",
    typeSea: "quote-type-sea",
    typeRoad: "quote-type-road",
    cargo: "quote-cargo",
    submit: "quote-submit",
    success: "quote-success",
  },
  coverage: {
    section: "coverage-section",
    region: (k) => `coverage-${k}`,
  },
  contact: {
    section: "contact-section",
    phone: "contact-phone",
    email: "contact-email",
    address: "contact-address",
    whatsapp: "contact-whatsapp",
  },
  footer: {
    container: "site-footer",
  },
};
